import React from 'react';

import Specs from './pdp-specs';
import Accessories from './accessories';
import Features from './features';
import SpecialOffers from '../../../product/components/special-offers';
import PDPMobileTabs from './pdp-mobile-tabs';
import Support from './support';
import Reviews from '../../../bv/components/bv-reviews';

import { Helpers } from '../../../core/src/helpers';
import { ErrorBoundary, withError } from '../../../shared/components/error-boundary';
import TabsContainer from '../../../shared/components/tabs-container'
import TabSelectBar from '../../../shared/components/tab-select-bar'
import Tabs from '../../../shared/components/tabs'
import Tab from '../../../shared/components/tab'
import withDeviceChange from '../../../ui/components/device-change';

import '../../css/pdp-offers.less';

const { memoize } = Helpers;

const ACC_TYPES = {
    Toner: ['samsung', 'laserjet'],
    Ink: ['deskjet', 'envy', 'officejet', 'pagewide', 'designjet', 'tango']
}
const DEFAULT_TAB_MAP = {
    "features": {
        "tabTitle": "Features",
        "hideTab": false
    },
    "specs": {
        "tabTitle": "Specs",
        "hideTab": false
    },
    "accessories": {
        //no default title for acessores so that the printer override takes affect
        "hideTab": false
    },
    "support": {
        "tabTitle": "Support",
        "hideTab": false
    },
    "specialOffers": {
        "tabTitle": "Special offers",
        "hideTab": false
    },
    "reviews": {
        "tabTitle": "Reviews",
        "hideTab": false
    }
}

class PDPTabs extends React.Component {

	static getAccType = (product) => {
        try
        {
            const productName = (product.name || "").toLowerCase();
            let category = (product.attributes || {}).pm_category;
            //temp fix for skus that have multiple pm_category
            if(Array.isArray(category)){
                category = category[0];
            }
            if(category && category.toLowerCase().includes('printer')) {
                for( let accType of Object.keys(ACC_TYPES)) {
                    if(ACC_TYPES[accType].some( printer => productName.includes(printer))) {
                        return accType;
                    }
                }
            }
            return null;
        }catch(e){
            return null;
        }
    }

    getTabIndex(tab) {
        let tabIndex;
        const { product } = this.props
        const { sku } = product;
        switch(typeof tab) {
            case "number":
                tabIndex = tab;
                break;
            case "string":
                tabIndex = this.pdpTabs(sku, product).findIndex(t => (t.name || '').toLowerCase() === tab.toLowerCase());
                break;
            default:
                tabIndex = 0;
        }
        return tabIndex;
    }

	pdpTabs = memoize(
        (sku, product) => {
            const { prdClass="",  attributes={}, pdpConfig={}} = product;
            const { tabTitles=[], hideTabs={}, pdpTabs={} } = pdpConfig;
            let { tabs: tabConfig=[] } = pdpTabs;
            //reduce tabConfig to key value map
            tabConfig = tabConfig.reduce((r,t,i) => {
                r[t.key] = Object.assign({},r[t.key],t);
                r[t.key].tabIndex = i;
                return r;
            },DEFAULT_TAB_MAP)

            const accType = PDPTabs.getAccType(product);

            let newTabs = [];

            if(!tabConfig['features'].hideTab){
                newTabs.push({name: tabConfig['features'].tabTitle || 'Features', component: (props) => <Features {...props}/>, trackName: 'prodDetailsTab', });
            }

            //add specs tab unless product has no specs
            if((!attributes || !attributes.hideSpecsTab) && !tabConfig['specs'].hideTab){
                newTabs.push({name: tabConfig['specs'].tabTitle || 'Specs', component: (props) => <Specs {...props}/>, trackName: 'prodDetailsTab', });
            }

            //add accessories tab if xsell are available
            if(product.xsell && product.xsell.length > 0 && !tabConfig['accessories'].hideTab) {
                const tabTitle = tabConfig['accessories'].tabTitle || (accType ? `${accType} & Paper` : 'Accessories');
                const accTab = {name: tabTitle, component: (props) => <Accessories {...props}/>, trackName: 'prodAccTab'};
                newTabs.push(accTab);
                //TODO: We should put carepacks seperate from other cross sells
                let carePacks = product.xsell.filter(p => {
                    const { attributes={} } = p;
                    return attributes.pm_category === 'HP Care Pack Services' && !/PE$/.test(p.sku);
                })
                if(carePacks.length > 0) {
                    const suppTab = {name: tabTitles[3] ? tabTitles[3] : 'Support', component: (props) => <Support {...props} carePacks={carePacks}/>, trackName: 'prodAccTab'};
                    newTabs.push(suppTab);
                }
            }

            //add offers tab if any
            if(!product.eol && product.offers && product.offers.length > 0 && !tabConfig['specialOffers'].hideTab) {
                newTabs.push({name: tabConfig['specialOffers'].tabTitle || 'Special Offers', component: (props) => <SpecialOffers {...props} />, trackName: 'prodDetailsTab'});
            }

            //finally add reviews
            if(!tabConfig['reviews'].hideTab && prdClass !== 'EXT'){
                newTabs.push({
                    name: tabConfig['reviews'].tabTitle || 'Reviews', 
                    component: (props) => {
                      /*  return (
                          IF YOU USING PREFETCH wrap in ABFSS since tab is prefetched, want to reduce impact on page load
                        <AboveTheFoldOnlyServerRender renderOn={'idle'} skip={true} idleBuffer={2000}>
                            <Reviews {...props}/>
                        </AboveTheFoldOnlyServerRender>
                        );*/
                        return <Reviews {...props}/>;
                    }, 
                    trackName: 'readReview', 
                    prefetch: false
                })
            }

            return newTabs;
        },(sku, product)=> `${sku}-${product.xsell ? product.xsell.length : 0}-${product.fromReduxCache}`
    );


	render(){
        const { tabIndex, product, purchaseButton, handleTabChange, device } = this.props;
        const tabs = this.pdpTabs(product.sku, product);

		return (					
				<React.Fragment>
				{
				device !== 'mobile' ?
				<TabsContainer tabIndex={this.getTabIndex(tabIndex)} handleTabChange={handleTabChange}>
					<TabSelectBar tabs={tabs} product={product}>
						{
						<ErrorBoundary>
							{ purchaseButton }
						</ErrorBoundary>
						}
					</TabSelectBar>
					<Tabs>
						{tabs.map((tab, i) =>
							<Tab key={i} prefetch={tab.prefetch}>
							    {tab.component({product, device})}
							</Tab>
						)}
					</Tabs>
				</TabsContainer> :
                <PDPMobileTabs 
                    tabIndex={this.getTabIndex(tabIndex)} 
                    tabs={tabs} product={product} 
                    device={device} 
                    handleTabChange={handleTabChange} 
                />
				}
				</React.Fragment>
		)	        
	}
}

export default withError(withDeviceChange(PDPTabs));
